// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__19bNY","footer":"ModalError_footer__3lydp"};